import React from 'react'
import Button from 'components/Button'
import Select from 'components/SelectOptions'
import { MAX_LINE_UPLOAD_CSV, optionEnCodingsDownloadCsv } from 'constants/misc'
import * as S from './style'

const BodyModal = ({
  file,
  onChangeModalUploadCsv,
  encodingType,
  hasErrorMultiple,
  setEncodingType,
  onHandleClickClose,
  handleUploadCsv,
}: {
  file: File | null
  hasErrorMultiple?: boolean
  onChangeModalUploadCsv: (e: any) => void
  encodingType: string
  setEncodingType: (value: string) => void
  onHandleClickClose: () => void
  handleUploadCsv: () => void
}) => {
  return (
    <>
      <S.Wrapper>
        <span>ファイル</span>
        <S.NameFile>{file?.name}</S.NameFile>
        <label htmlFor="modal-upload-csv-booking">
          <Button color="blue" onClick={(e: any) => e.target.parentNode.click()}>
            選択
            <S.InputHidden
              id="modal-upload-csv-booking"
              type="file"
              accept=".csv"
              onChange={onChangeModalUploadCsv}
              onClick={(e: any) => (e.target.value = '')}
            />
          </Button>
        </label>
      </S.Wrapper>
      <S.Wrapper>
        <Select
          name="encoding-type"
          label="文字コード"
          options={optionEnCodingsDownloadCsv}
          selectValue={encodingType}
          handleUpdateData={(value: string) => setEncodingType(value)}
          width={'140px'}
        />
      </S.Wrapper>
      {hasErrorMultiple && (
        <S.AlertText>入稿行数が{MAX_LINE_UPLOAD_CSV}行を超えています。</S.AlertText>
      )}
      <S.Footer>
        <S.CustomButton color="lightBlue" onClick={onHandleClickClose}>
          キャンセル
        </S.CustomButton>
        <S.CustomButton
          color="blue"
          disabled={!Boolean(file) || !file?.name.endsWith('.csv') || hasErrorMultiple}
          onClick={handleUploadCsv}
        >
          アップロード
        </S.CustomButton>
      </S.Footer>
    </>
  )
}

export default BodyModal
